var _g, _defs, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebServer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 570,
    viewBox: "0 0 306 570",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2 2.20007C9.93334 3.26673 6.33334 6.3334 4.20001 9.1334L0.333344 14.0667V285V555.933L4.20001 560.867C11.2667 570.2 2.46668 569.667 153 569.667C303.533 569.667 294.733 570.2 301.8 560.867L305.667 555.933V285V14.0667L301.8 9.1334C294.733 -0.199932 303.533 0.333401 152.733 0.333401C40.8667 0.466735 15.5333 0.733401 12.2 2.20007ZM270.067 116.6L270.333 189.667H153H35.6667V117.133C35.6667 60.3334 36.0667 44.4667 37.4 43.9334C38.2 43.5334 90.8667 43.4001 154.333 43.5334L269.667 43.6667L270.067 116.6ZM171.267 359.133C184.467 365.533 191.667 376.467 192.733 391.8C193.533 405.267 190.6 413.533 181.8 422.467C165 439.267 140.333 439.133 124.067 422.2C115.267 413 112.467 405 113.267 391.8C114.067 381 117 374.2 124.333 366.6C136.867 353.667 154.067 350.867 171.267 359.133ZM262.333 515V523H153H43.6667V515V507H153H262.333V515Z",
    fill: "#2A4E69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6 83.9334L51 109H153H255L255.4 83.9334L255.667 59.0001H153H50.3333L50.6 83.9334Z",
    fill: "#2A4E69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3333 149.667V175H153H255.667L255.4 149.933L255 125L152.733 124.6L50.3333 124.333V149.667Z",
    fill: "#2A4E69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.267 372.467C127.133 379.533 123.533 398.6 133.933 411.133C146.067 425.533 169.667 421.4 176.467 403.667C184.733 382.067 162.2 362.2 141.267 372.467Z",
    fill: "#2A4E69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.889 347.896H87.2221V454.563H193.889V347.896Z",
    fill: "#2A4E69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306,
    height: 570,
    fill: "white"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    x: "50.5%",
    y: "48%",
    alignmentBaseline: "middle",
    textAnchor: "middle",
    fontSize: 50,
    fontWeight: 600,
    fontStyle: "italic"
  }, "\n    WEB\n")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    x: "50.5%",
    y: "60%",
    alignmentBaseline: "middle",
    textAnchor: "middle",
    fontSize: 50,
    fontWeight: 600,
    fontStyle: "italic"
  }, "\n    SERVER\n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebServer);
export default __webpack_public_path__ + "static/media/web-server.ee266d5a082e959c5f5b9d025b6a3bdc.svg";
export { ForwardRef as ReactComponent };